//
// helpers/collection-listener.js - add/remove events listeners for collections
//

function add(collection, event, handler) {
  Array.from(collection).forEach(el => el.addEventListener(event, handler));
}

function remove(collection, event, handler) {
  Array.from(collection).forEach(el => el.removeEventListener(event, handler));
}

export {
  add,
  remove,
};
